<dx-popup
  [(visible)]="visible"
  [width]="560"
  [height]="'auto'"
  [showTitle]="true"
  [dragEnabled]="true"
  [hideOnOutsideClick]="false"
  [showCloseButton]="true"
  [title]="title"
  (onHiding)="close()"
>
  <div *dxTemplate="let data of 'content'" class="dataprocess-workflow-dialog">

    <div class="dataprocess-workflow-dialog__body">
      <div *ngIf="!workflow" class="text-muted">
        {{ 'Kein Workflow geladen.' | translate }}
      </div>

      <div *ngIf="workflow" class="dataprocess-workflow-dialog__form">
        <div class="dataprocess-workflow-dialog__field">
          <div class="text-muted dataprocess-workflow-dialog__label">
            {{ 'Name' | translate }}
          </div>

          <dx-text-box
            [(value)]="workflow.name"
            [showClearButton]="true"
            [placeholder]="('Workflownamen vergeben' | translate)"
            stylingMode="outlined"
          ></dx-text-box>
        </div>
      </div>
    </div>

    <div class="dataprocess-workflow-dialog__footer d-flex justify-content-end gap-2">
      <dx-button
        stylingMode="outlined"
        type="default"
        text="{{ 'Abbrechen' | translate }}"
        (onClick)="close()"
      ></dx-button>

      <dx-button
        stylingMode="outlined"
        type="default"
        text="{{ 'Speichern' | translate }}"
        [disabled]="!workflow || !(workflow.name?.trim()?.length > 0)"
        (onClick)="save()"
      ></dx-button>
    </div>

  </div>
</dx-popup>
